"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var govMointor_1 = require("./govMointor");
try {
    var observer = new PerformanceObserver(function (list) {
        var perfEntries = list.getEntries();
        for (var i = 0; i < perfEntries.length; i++) {
            var dataToSend = {
                "entryType": perfEntries[i]["entryType"],
                "name": perfEntries[i]["name"]
            };
            //@ts-ignore
            govMointor_1.default.api('longtask', true, 0, 'longtask', JSON.stringify(dataToSend));
        }
    });
    observer.observe({ entryTypes: ["longtask"] });
}
catch (e) {
}
